import React, { useState, useEffect } from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import { colors, fonts, size } from "../../ColorFont/color";
import Carousel from "react-material-ui-carousel";
import {
  SubdirectoryArrowRight,
} from "@mui/icons-material";
import { url } from "../../ConstUrl/Url";

const PurchasedPlotsPopup = ({ buyerId, isOpen, onClose }) => {
  const [purchasedPlots, setPurchasedPlots] = useState([]);

  useEffect(() => {
    if (buyerId) {
      fetch(`${url}/api/purchasedPlots/${buyerId}`)
        .then((response) => response.json())
        .then((data) => {
          setPurchasedPlots(data.purchasedPlots || []);
        })
        .catch((error) =>
          console.error("Error fetching purchasedPlots:", error)
        );
    }
  }, [buyerId]);

  if (!isOpen) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          width: "80%",
          height: "80%",
          backgroundColor: "white",
          padding: 2,
          borderRadius: 2,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', marginBottom:2}}>
          <Typography
            sx={{
              fontFamily: fonts.poppins,
              fontSize: size.title,
              color: colors.primary_dark,
              marginBottom: 2,
              fontWeight: 600,
            }}
          >
            Purchased Plots
          </Typography>

          <Button
            onClick={onClose}
            variant="contained"
            size="small"
            sx={{ backgroundImage: colors.button, fontFamily: fonts.poppins }}
          >
            Close
          </Button>
        </Box>

        {purchasedPlots.length === 0 ? (
          <Typography
            sx={{
              fontFamily: fonts.poppins,
              fontSize: size.formLabel,
              color: colors.primary_dark,
            }}
          >
            No purchased plots found.
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 5,
            }}
          >
            {purchasedPlots.map((plot, index) => (
              <Card
                key={index}
                sx={{
                  width: "30%",
                  borderRadius: "30px",
                  background: colors.background,
                  border: "1px solid rgba(128, 128, 128, 0.5)", // Light gray with transparency
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ position: "relative" }}>
                  {Array.isArray(plot.photos) && plot.photos.length > 0 ? (
                    plot.photos.length > 1 ? (
                      <Carousel
                        autoPlay={false}
                        indicators={false}
                        navButtonsAlwaysVisible
                        navButtonsProps={{
                          style: {
                            backgroundColor: colors.background,
                            opacity: "50%",
                            color: colors.primary_dark,
                            padding: 5,
                            marginInline: 20,
                          },
                        }}
                      >
                        {plot.photos.map((photo, idx) => (
                          <img
                            key={idx}
                            src={`${url}/${photo}`}
                            alt={`Plot ${index} - Image ${idx}`}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "cover",
                              borderRadius: "30px",
                              padding: "16px",
                            }}
                          />
                        ))}
                      </Carousel>
                    ) : (
                      <img
                        src={`${url}/${plot.photos[0]}`}
                        alt={`Plot ${index} - Image`}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          borderRadius: "30px",
                          padding: "16px",
                        }}
                      />
                    )
                  ) : (
                    <img
                      src="default/default.png"
                      alt="Default Placeholder"
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "30px",
                        padding: "16px",
                      }}
                    />
                  )}

                  <Box sx={{ marginBottom: 2, paddingInline: "14px" }}>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                      }}
                    >
                      {plot.category.map((category, i) => {
                        return (
                          <>
                            {category}
                            {i < plot.category.length - 1 && ", "}{" "}
                          </>
                        );
                      })}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <SubdirectoryArrowRight />
                      <Typography
                        sx={{
                          fontFamily: fonts.poppins,
                          fontSize: size.subtitle,
                          fontWeight: 600,
                          color: colors.primary_dark,
                        }}
                      >
                        {plot.subCategory}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                      gap: 1,
                      paddingInline: "14px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.text,
                        fontWeight: 600,
                      }}
                    >
                      Address:
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.formLabel,
                      }}
                    >
                      {plot.state || "Unknown State"},{" "}
                      {plot.taluka || "Unknown Taluka"}
                    </Typography>
                  </Box>
                </Box>

                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1,
                      marginBottom: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontFamily: fonts.poppins,
                          fontSize: size.text,
                        }}
                      >
                        Area:
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: fonts.poppins,
                          fontSize: size.formLabel,
                        }}
                      >
                        {plot.area || "N/A"} Ghuntas
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontFamily: fonts.poppins,
                          color: colors.primary_dark,
                          fontWeight: 600,
                          fontSize: size.title,
                        }}
                      >
                        ₹{plot.amount || "N/A"}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      width: "100%", // Makes it full width
                      display: "flex",
                      justifyContent: "center", // Centers horizontally
                    }}
                  >
                    <Box
                      sx={{
                        textAlign: "center",
                        backgroundColor: "green",
                        borderRadius: 10,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "6px 16px",
                        width: "100%", // Ensures it takes full available width
                        maxWidth: "500px", // Optional: Prevents it from being too wide on large screens
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", // Realistic depth
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: fonts.poppins,
                          fontWeight: 600,
                          fontSize: size.text,
                          color: "white",
                        }}
                      >
                        {plot.contactNumber || "no phone number"}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PurchasedPlotsPopup;
